import { render } from "./FooterView.vue?vue&type=template&id=5e7a37f6"
import script from "./FooterScript.vue?vue&type=script&lang=js&external"
export * from "./FooterScript.vue?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__